var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { fieldValueInStorage } from "../../services/helperLib";
import Ratings from "./Ratings";
var categoriesMap = {
    "group1-LoanType": "Loan Type",
    "group2-PropertyInfo": "Property Info",
    "group3-LoanDetails": "Loan Details",
    "group4-AboutYou": "About",
};
export default function ProgressCategories(_a) {
    var activeSlide = _a.activeSlide, navGroups = _a.navGroups, _b = _a.isLastStep, isLastStep = _b === void 0 ? false : _b, flow = _a.flow;
    var currentCatIndex = navGroups
        ? navGroups.findIndex(function (ng) { return ng.pages.includes(activeSlide || ""); })
        : 0;
    var loanTypeText = "";
    try {
        var lp = fieldValueInStorage("loanPurpose");
        if (lp) {
            var clean = lp.toString().split("|")[1] || lp;
            loanTypeText = "Loan Type: ".concat(clean.charAt(0).toUpperCase()).concat(clean.slice(1).toLowerCase());
        }
    }
    catch (_c) { }
    return (_jsxs("aside", { className: "progress-categories", "aria-label": "Progress sidebar", children: [_jsx("div", { className: "progress-categories-logo", children: _jsx("a", { href: "/", children: _jsx("img", { src: "https://assets.newamericanfunding.com/images/logos/logo-new-american-funding.svg", alt: "New American Funding logo" }) }) }), _jsxs("div", { className: "progress-categories-intro", children: [_jsx("h3", { className: "progress-categories-intro-title", children: "Let's Get Started" }), _jsx("p", { className: "progress-categories-intro-desc", children: "It only takes about 3 minutes. This won't affect your credit score." })] }), _jsx("nav", { className: "progress-categories-tracker-block", "aria-label": "Loan application progress", children: _jsx("ul", { className: "progress-categories-tracker", children: navGroups &&
                        navGroups.map(function (cat, idx) {
                            var stepClass = "";
                            if (idx < currentCatIndex)
                                stepClass = "completed";
                            else if (idx === currentCatIndex)
                                stepClass = isLastStep ? "completed" : "current";
                            var props = {};
                            if (stepClass)
                                props["className"] = stepClass;
                            var label = cat.id === "group1-LoanType" && loanTypeText
                                ? loanTypeText
                                : categoriesMap[cat.id];
                            return (_jsx("li", __assign({}, props, { "aria-current": stepClass === "current" ? "step" : undefined, children: _jsx("p", { children: label }) }), cat.id));
                        }) }) }), _jsx(Ratings, {})] }));
}
